// extracted by mini-css-extract-plugin
export var l = "spacer-module--l--K3A6o";
export var m = "spacer-module--m--VA41c";
export var s = "spacer-module--s--EY0Yi";
export var xl = "spacer-module--xl--Mn9Qj";
export var xxl = "spacer-module--xxl--q42EJ";
export var xxxl = "spacer-module--xxxl--o0Aik";